module.exports = __webpack_public_path__ + "img/MariaDB.0224b9d.svg";